module.exports = __webpack_public_path__ + "static/media/treasurer.5085b894.jpeg";